(function (window, $) {
    $('body').on('click', '.delete-account-button', deleteAccountConfirm);

    /**
     * Delete account confirm.
     *
     * @return undefined
     */
    function deleteAccountConfirm() {
        var elem = $(this);

        if (elem.attr('data-confirm-delete')) {
            if (!window.confirm(elem.attr('data-confirm-delete'))) {
                return;
            }
        }

        $.ajax({
            type: 'delete',
            url: elem.attr('data-url'),
            dataType: 'json',
            success: function (data) {
                ga('send', 'event', 'Accounts', 'Successfully deleted account', 'Account Events');
                if (data.type === 'alert-success') {
                    window.location.replace(elem.attr('data-redirect-url'));
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (jqXHR.responseText) {
                    try {
                        var data = JSON.parse(jqXHR.responseText);

                        alert(data.content);
                    } catch (SyntaxError) {
                        alert(jqXHR.responseText);
                    }
                } else {
                    alert('Could not delete account, contact administator if this error occurs again');
                }
            }
        });
    }
})(window, jQuery);
